/* Sincroniza la línea del fee de grabado de texto con el carrito.
 *
 * Regla: la cantidad del fee (línea con property _text_fee) debe ser igual
 * a la suma de cantidades de las líneas con property _fee_variant (termos
 * personalizados con texto, ver buildCartItems en product-v2.js).
 *
 * Cubre: cliente borra la línea del fee (se re-agrega), cliente borra el
 * termo (el fee se quita), cliente cambia cantidades (el fee las sigue).
 * Tras corregir recarga la página para que el carrito/drawer refleje el
 * estado real. Guard anti-loop: máximo 3 correcciones por minuto.
 */
(function () {
  'use strict';

  var busy = false;

  function guardOk() {
    try {
      var now = Date.now();
      var log = JSON.parse(sessionStorage.getItem('ctfsLog') || '[]')
        .filter(function (t) { return now - t < 60000; });
      if (log.length >= 3) return false;
      log.push(now);
      sessionStorage.setItem('ctfsLog', JSON.stringify(log));
      return true;
    } catch (e) {
      return true;
    }
  }

  function computeFix(cart) {
    var expected = 0;
    var feeVariantId = 0;
    var feeLines = [];
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (p._text_fee) {
        feeLines.push({ key: item.key, quantity: item.quantity });
        if (!feeVariantId) feeVariantId = item.variant_id;
      } else if (p._fee_variant) {
        expected += item.quantity;
        feeVariantId = parseInt(p._fee_variant, 10) || feeVariantId;
      }
    });
    var actual = 0;
    feeLines.forEach(function (l) { actual += l.quantity; });
    if (actual === expected) return null;
    return { expected: expected, feeVariantId: feeVariantId, feeLines: feeLines };
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Resuelve a true solo si todas las peticiones respondieron OK; si algo
  // falla (ej. producto fee agotado/borrado) NO se recarga, para no ciclar
  function applyFix(fix) {
    var ok = true;
    function track(r) {
      if (!r || !r.ok) ok = false;
      return r;
    }
    var steps;
    if (fix.feeLines.length === 0) {
      // No hay línea del fee pero hay termos con texto → re-agregarla
      if (!fix.feeVariantId) return Promise.resolve(false);
      steps = postJson('/cart/add.js', {
        items: [{ id: fix.feeVariantId, quantity: fix.expected, properties: { '_text_fee': '1' } }]
      }).then(track);
    } else {
      // Ajustar la primera línea del fee a la cantidad esperada (0 la elimina)
      // y vaciar cualquier línea del fee duplicada
      steps = postJson('/cart/change.js', { id: fix.feeLines[0].key, quantity: fix.expected }).then(track);
      fix.feeLines.slice(1).forEach(function (l) {
        steps = steps.then(function () {
          return postJson('/cart/change.js', { id: l.key, quantity: 0 }).then(track);
        });
      });
    }
    return steps.then(function () { return ok; });
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fix = computeFix(cart);
        if (!fix) { busy = false; return; }
        if (!guardOk()) { busy = false; return; }
        return applyFix(fix).then(function (ok) {
          if (ok) window.location.reload();
          else busy = false;
        });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Carrito vacío (sin burbuja del header) y fuera de /cart: nada que
    // sincronizar, ahorra el fetch inicial en cada página
    var hasItems = document.querySelector('.cart-count-bubble') ||
                   location.pathname.indexOf('/cart') === 0;
    if (hasItems) check();
    // Re-verificar tras cualquier mutación del carrito (pubsub del tema)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        // Pequeño delay: dejar que el tema termine su propio fetch/render
        setTimeout(check, 400);
      });
    }
  });

  // Regreso desde checkout/carrito con bfcache: el estado pudo cambiar
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) check();
  });
})();
